<template>
    <div class="blackBg animate__animated animate__slideInLeft">
        <div class="cardTit">
            <span class="teamName">{{teamName?teamName:'XXX'}}</span>
        </div>
        <div class="lesson" v-if="videoList.length">
            <div class="videoList">
                <div class="item" v-for="(item,index) in videoList" :key="item.id">
                    <span class="number">{{index+1}}</span>
                    <img :src="item.snapshot ? item.snapshot : require('@/assets/img/updateImg/exerciseBg.png')" alt="">
                    <div class="message">
                        <p class="list-item-tit-msg">{{item.name}}</p>
                        <p class="list-item-tit-date">{{$global.formatDate(new Date(item.createTime), 'yyyy/MM/dd HH:mm:ss', true)}}</p>
                    </div>
                </div>
              <div v-if="!videoList.length" class="cardBg" style="height: 30vw;text-align: center;font-size: 26px;line-height: 30vw">暂无数据</div>
            </div>
            <div class="footer">
                <span class="prev" @click="changePage(-1)">上一页</span>
                <span class="next" @click="changePage(1)">下一页</span>
                <span class="page"><i>{{page}}</i>/{{totalPages}}</span>
            </div>
        </div>
        <div v-else class="cardBg" style="line-height: 35vw;color: #fff;font-size: 26px;text-align: center">暂无数据</div>
    </div>
</template>

<script>
    export default {
        name: "videoList",
        data() {
            return {
                teamName: this.$store.state.teamName ? this.$store.state.teamName.split('_')[0] : '',//梯队名称
                videoList: [],
                page: 1,//页码
                totalPages: 0,//总页数
            }
        },
        computed: {
            lookCommandFn() {
                return this.$store.state.lookCommand;
            },
            teamId() {
                return this.$store.state.teamId;
            }
        },
        watch: {
            page: {
                handler(val, old) {
                    this.getVideoList();
                },
                deep: true
            },
            lookCommandFn: {
                async handler(val, old) {
                    let videoList = this.videoList;
                    let prevPage = this.$aiJson.prevPage;
                    let nextPage = this.$aiJson.nextPage;
                    let flag = 0;
                    let speak = '';
                    let routerObj = {};
                    //数字号判断
                    for (let item = 0; item < videoList.length; item++){
                        if (eval('/' + this.$aiJson.itemNum[item] + '号' + '/gi').test(val)) {
                            flag = 1;
                            //查看详情
                            speak = 'detail';
                            routerObj={
                                path: '/about/videoClipList',
                                name: 'videoClipList',
                                query: {
                                    id: this.videoList[item].id,
                                    name: this.videoList[item].name,
                                    img: this.videoList[item].snapshot,
                                    date: this.videoList[item].createTime,
                                    page: this.page,
                                },
                                goType:1
                            }
                            break;
                        } else {
                            flag = 0;
                        }
                    }

                    //上一页判断
                    if(!flag){
                        for (let item = 0; item < prevPage.length; item++){
                            if (eval('/' + prevPage[item] + '/gi').test(val)) {
                                flag = 1;
                                speak = this.page != 1 ? '上一页的视频' : '';
                                this.changePage(-1);
                                break;
                            } else {
                                flag = 0;
                            }
                        }
                    }
                    //下一页判断
                    if(!flag){
                        for (let item = 0; item < nextPage.length; item++){
                            if (eval('/' + nextPage[item] + '/gi').test(val)) {
                                flag = 1;
                                speak = this.page != this.totalPages ? '下一页的视频' : '';
                                this.changePage(1);
                                break;
                            } else {
                                flag = 0;
                            }
                        }
                    }

                    if(flag){
                        if(speak!=''){
                            if(speak == 'detail'){
                                this.$store.dispatch("setFlag",'1_'+new Date().getTime());//vuex改变识别信息

                                this.$store.dispatch("setRouter", routerObj);//vuex改变路由
                            }else {
                                this.$parent.$parent.imgAi(this.$imgJson.handAiImgArr);
                                this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl('这是训练视频，请查收！'), true, false)
                            }
                        }
                    }else {
                        this.$store.dispatch("setFlag",'0_'+new Date().getTime());//vuex改变识别信息
                    }
                },
                deep: true
            },
          teamId(val, old) {
            if (val != old) {
              this.teamName = this.$store.state.teamName.split('_')[0];
                this.page = 1;
              this.getVideoList()
            }
          },
        },
        mounted() {
            if (this.$store.state.pageParams.id) {
                this.page = this.$store.state.pageParams.page;
            }
            if (this.page == 1) {
                this.getVideoList();
            }
        },
        methods: {
            getVideoList() {
                let data = {
                    teamId: this.teamId,
                    // teamId: '5f09beab2bbde45f19a055b7',
                    paging: true,
                    pageSize: 8,
                    page: this.page,
                }
                this.$server.getVideoList(data)
                    .then(res => {
                        this.videoList = res.data.list;
                        this.totalPages = res.data.pages;
                    })
            },
            //翻页
            changePage(type) {
                console.log(type)
                if (type > 0) {
                    if (this.page == this.totalPages) {
                        //当前是最后一页
                        this.$parent.$parent.imgAi(this.$imgJson.taskAiImgArr);
                        this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl(this.$aiJson.playVoice.lastPage), true, false)
                    } else {
                        this.page++
                    }
                } else {
                    if (this.page == 1) {
                        //当前是第一页
                        this.$parent.$parent.imgAi(this.$imgJson.taskAiImgArr);
                        this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl(this.$aiJson.playVoice.firstPage), true, false)
                    } else {
                        this.page--
                    }
                }
            },
        }
    }
</script>

<style scoped lang="less">
    .cardTit {
        margin-top: 2vw;
        font-size: 30px;
        box-sizing: border-box;
        position: relative;
        .tagsList{
            color: #fff;
            position: absolute;
            left: 1vw;
            top: .4vw;
            span{
                box-sizing: border-box;
                background-color: rgba(216, 216, 216, .1);
                color: rgba(255, 255, 255, .6);
                font-size: 24px;
                padding: 0.2vw .8vw;
                margin-right: 0.5vw;
                &.check{
                    border: 1px solid var(--primary-color);
                    color: var(--primary-color);
                    background-color: rgba(66, 165, 245, 0.3);
                }
            }
        }
    }
    .videoList {
        color: #fff;
        margin-top: 0.5vw;
        min-height: 28vw;

        .item {
            width: calc((100% - (1vw*3)) / 4);
            float: left;
            margin-right: 1vw;
            margin-bottom: 1.5vw;
            position: relative;
            overflow: hidden;
            height: 13vw;
            background: rgba(14, 14, 14, 0.7);
            border: 2px solid rgba(255, 255, 255, 0.1);
            box-sizing: border-box;
            &:nth-child(4n){
                margin-right: 0;
            }

            img {
                /*height: 100%;*/
                width: 100%;
            }
            .number{
                border: 2px solid rgba(255, 255, 255, 0.3);
                width: 2vw;
                height: 2vw;
                background-color: var(--primary-color);
                border-radius: 50%;
                text-align: center;
                line-height: 1.8vw;
                font-size: 34px;
                position: absolute;
                font-family: akrobatBold;
                top: .2vw;
                left: .2vw;
            }
            .message{
                color: rgba(255, 255, 255,.8);
                font-size: 22px;
                width: 100%;
                padding: .3vw .5vw;
                box-sizing: border-box;
                .list-item-tit-msg{
                    line-height: 1.5vw;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space:nowrap;
                    color: #fff;
                }
                .list-item-tit-date{
                    font-size: 20px;
                    margin-top: .2vw;
                    color: rgba(255, 255, 255, .6);
                }
            }
        }
    }
</style>
